import { useContext } from "react";
import { ProjectContext } from "./project-context-props.ts";

export const useOptionalProjectContext = () => useContext(ProjectContext);

const useProjectContext = () => {
    const context = useContext(ProjectContext);
    if (!context) {
        throw new Error("useProjectContext must be used within a ProjectContextProvider");
    }
    return context;
}

export default useProjectContext;